import { render, staticRenderFns } from "./OtherVendorsModal.vue?vue&type=template&id=26d18b6e&scoped=true&"
import script from "./OtherVendorsModal.vue?vue&type=script&lang=js&"
export * from "./OtherVendorsModal.vue?vue&type=script&lang=js&"
import style0 from "./OtherVendorsModal.vue?vue&type=style&index=0&id=26d18b6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26d18b6e",
  null
  
)

export default component.exports